import axios from '@/api/config';
const examSetting = {
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/examSetting/pageList`, data)
  },
  addExam(data) {
    return axios.post(`${process.env.BASE_URL}/examSetting/addExam`, data)
  },
  addExamSetting(data) {
    return axios.post(`${process.env.BASE_URL}/examSetting/addExamSetting`, data)
  },
  updateExam(data) {
    return axios.put(`${process.env.BASE_URL}/exam/updateExam`, data)
  },
  updateExamSetting(data) {
    return axios.put(`${process.env.BASE_URL}/examSetting/updateExamSetting`, data)
  },
  deleteExam(data) {
    return axios.delete(`${process.env.BASE_URL}/exam/deleteExam`, {
      data: data
    })
  },
  deleteExamSetting(data) {
    return axios.delete(`${process.env.BASE_URL}/examSetting/deleteExamSetting`, {
      data: data
    })
  },
  getSubjectCourseExamCount(data) {
    return axios.get(`${process.env.BASE_URL}/examSetting/getExamCount`, {
      params: data
    })
  },
  getExamCount(data) {
    return axios.get(`${process.env.BASE_URL}/examSetting/getExamCount`, {
      params: data
    })
  },
  getExamSettingList(data) {
    return axios.get(`${process.env.BASE_URL}/examSetting/getExamSettingList`, {
      params: data
    })
  },
  // 获取考试期数
  getExamSequenceList(data) {
      return axios.get(`${process.env.BASE_URL}/examinationStudent/getGradeSequence`, {
      params: data
    })
  },
  getExamSettingListForSign(data) {
    return axios.get(`${process.env.BASE_URL}/examSetting/getExamSettingListForSign`, {
      params: data
    })
  },
  getExam(data) {
    return axios.get(`${process.env.BASE_URL}/exam/getExam`, {
      params: data
    })
  },
  getExamList(data) {
    return axios.get(`${process.env.BASE_URL}/exam/getExamList`, {
      params: data
    })
  },
  getExamSettingRelationList(data) {
    return axios.get(`${process.env.BASE_URL}/examSettingRelation/getExamSettingRelationList`, {
      params: data
    })
  },
  generateSequence(data) {
    return axios.get(`${process.env.BASE_URL}/examSetting/generateSequence`, {
      params: data
    })
  }
}
export default examSetting



// WEBPACK FOOTER //
// ./src/api/examSetting.js